import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  generateVoAFiservreports({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoAFiservReport.voaFiservOrderReport
    }`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  async fetchVoAFiservreports({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.VoAFiservReport.GetFiservOrderDetails
        }?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  async generatepdfReport({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoAFiservReport.getAccountDetails
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  fetchMaxDataReport({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.VoAFiservReport.fetchMaxDataReport}?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async viewpdfReport({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.VoAFiservReport.getViewReport
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async voaAccountsEnrolled({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoAFiservReport.accountsEnrolled
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async fetchSignonInfo({ state }, orderID) {
    // let orderID = payload.orderId
    // delete payload.orderId
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoAFiservReport.voaFiservSignon
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async resendInvitationEmail({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.VoAFiservReport.resendEmail
        }?orderId=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  voaFiservDeleteUser({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoAFiservReport.voaFiservDeleteUser
    }/${payload.orderId}/${payload.userID}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  voaFiservNoOtpGuid({ state }, { guid }) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.VoAFiservReport.onlyGuid
    }/${guid}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  const path = window.location.href
  const url =
    path.includes('fiserv-widgets/') || path.includes('voa-fiserv-thanks')
  if (url) {
    return {
      'Content-Type': 'application/json',
      Authorization: '',
    }
  } else {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    }
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
